import p1 from "../../Assets/projects/img55.png";
import p2 from "../../Assets/projects/img33.png";
import p3 from "../../Assets/projects/img44.png";
import p4 from "../../Assets/projects/img6.png";
import p5 from "../../Assets/projects/img77.png";

const projectData = [
  {
    id: 1,
    title: "Soil-Properties-Automation",
    img: p1,
    description:
      "I have developed a React.js automation project that streamlines and automates various processes involved in evaluating soil properties and generating chart images and files. The project focuses on the evaluation of the friction angle and elastic modulus of frictional soil.",
    programmingLanguage: [
      "React.js",
      " React Chart.js",
      " React CSV",
      "xlsx",
      "html2canvas",
    ],
    features: [
      "User-friendly design and easy to use",
      "Read data from multiple files",
      "Generate and export:  New file with and Chart image",
      "Multiple select table rows and apply actions",
      "Error handling for data processing",
    ],
    links: {
      github: "https://github.com/Mohamed-Salah991/Soil-Properties-Automation",
      liveDemo:
        "https://github.com/Mohamed-Salah991/Soil-Properties-Automation",
    },
  },
  {
    id: 2,
    title: "E-commerce",
    img: p2,
    description:
      "have completed the development of my E-Commerce application using React.js! The application is fully responsive and built using pure CSS. Rather than relying on a UI framework, I decided to challenge myself by building the application with pure CSS, enabling me to use a framework with confidence in the future",
    programmingLanguage: [
      "React.js",
      " React Router Dom",
      " Redux/toolkit",
      "React icons",
      "Swiper Slider",
    ],
    features: [
      "Full Responsive ( pure CSS )",
      "Filter, Sort in Shop page",
      "Search bar connected to the shop page",
      "Product Quick view using React Portal",
      "Client side pagination",
      "Two product views (Grid view, List view)",
      "Cart and Wish List functionality",
    ],
    links: {
      github: "https://github.com/Mohamed-Salah991/E-Commerce",
      liveDemo: "https://e-commerce-a526b.web.app/",
    },
  },
  {
    id: 3,
    title: "Quiz-Game",
    img: p3,
    description:
      "Welcome to Quiz Game, a simple web-based game that tests your knowledge on various topics. This game is built using HTML, CSS, and JavaScript and is designed to be easy to play.",
    programmingLanguage: [
      "HTML",
      " CSS",
      " JS",
      "DOM Manipulation",
      "CSS Grid",
      "CSS Flex Box",
    ],
    features: [
      "User-friendly interface with clear instructions and easy-to-use buttons",
      "Multiple-choice questions on a variety of topics",
      "Randomized order of questions to keep the game interesting",
      "Automatic scoring system that calculates your score as you play",
      "Final score display at the end of the quiz",
    ],
    links: {
      github: "https://github.com/Mohamed-Salah991/Quiz-Game",
      liveDemo: "https://mohamed-salah991.github.io/Quiz-Game/",
    },
  },
  {
    id: 5,
    title: "Food Order ",
    img: p5,
    description:
      "This project is a dynamic shopping cart simulation built with React.js, showcasing the implementation of cart functionality commonly seen in e-commerce platforms. Leveraging the power of React's state management system, the project offers an immersive and seamless user experience.",
    programmingLanguage: [
      "React",
      "Context API",
      "React Hooks",
      "React State Management",
    ],
    features: [
      "All cart functionality",
      "Apply Context API",
      "Apply clean up with use-Effect ",
    ],
    links: {
      github: "https://github.com/Mohamed-Salah991/Meals-App",
      liveDemo: "https://meals-app-cefef.web.app/",
    },
  },
  {
    id: 4,
    title: "Omnifood ",
    img: p4,
    description:
      "Experience a fully responsive website design using HTML and CSS. This project utilizes modern CSS properties like CSS Grid and Flexbox to ensure responsiveness across all screen sizes. JavaScript is used for interactive navigation. Explore the project for a visually appealing and user-friendly website.",
    programmingLanguage: ["HTML", "CSS", " JS", "CSS Grid", "CSS Flex Box"],
    features: [],
    links: {
      github: "https://github.com/Mohamed-Salah991/Omnifood-Responsive",
      liveDemo: "https://mohamed-salah991.github.io/Omnifood-Responsive/",
    },
  },
];

export default projectData;
